function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "allow_zero_value_cart": false,
    "watch_for_missing_transfer_button": true,
    "transfer_button_container_selector": ".cart-drawer__checkout-buttons",
    "transfer_label":"Transfer Cart",
    "custom_style":"body.punchout a.header__icon.header__icon--account.link.focus-inset.small-hide {display: none;}",
    "checkout_selector":"button[name=\"checkout\"]", 
    "transfer_selector":"button[name=\"transfer_items\"]", 
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"btn btn--primary btn--icon-with-text w-full\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "header", 
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>",
  
    /************ Add the following lines *************/
    // list of metafields that should be transfered with the return cart
    // only required for metafields, barcodes are always transferred
    "cart_transfer_metafields": [
      "custom.unspsc_code"
    ],
    "graphql_token": "233f146f63cce2fb8c8baa8db0a02758"
/**************************************************/    
  
  };
    POExt = new Po2go_Shopify(store_config);      
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    let POUpdateTransferCartHandle = setInterval(() => {
        if(document.getElementById('CartDrawer').checkVisibility()) {
            POSession.extension.setupPage();
            clearInterval(POUpdateTransferCartHandle);
        }
    }, 200);
  });

}

function tc_getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
} 

if (tc_getCookie("pos_id") != null && tc_getCookie("pos_id") != "") {
  setTimeout(() => {
    /* add this HTML... <button type="submit" name="transfer_items" class="cart__checkout-button button" href="/cart">View Cart</button> */
    const new_button = document.createElement("a");
    const t = document.createTextNode("View Cart");
    new_button.appendChild(t);
    new_button.setAttribute("type", "submit");
    new_button.setAttribute("name", "view_cart");
    new_button.setAttribute("class", "cart__checkout-button button");
    new_button.setAttribute("href", "/cart");
    const original_button = document.getElementById("checkout");
    const parent_div = original_button.parentNode;
    parent_div.append(new_button);
  }, 3000);
}